import { ReactNode, useRef, useState } from "react";
import { Size, useResizeObserver } from "@/hooks/use-resize-observer";

export const ResponsiveContainer = ({
  children,
  className,
}: {
  children: (size: Size) => ReactNode;
  className?: string;
}) => {
  const ref = useRef<HTMLDivElement>(null);
  const [size, setSize] = useState<Size>();

  useResizeObserver({ ref, onResize: setSize });

  return (
    <div ref={ref} className={className}>
      {size && children(size)}
    </div>
  );
};
